export default __webpack_public_path__ + "static/live-hero-one-right-db00664fbecf85ed50b0ea1bf1466983.webp";